import { createContext } from 'react';
import { SearchEngine } from '@coveo/headless';
import { buildRecommendationEngine } from '@coveo/headless/recommendation';
export interface ICoveoSearchInterfaceContext {
  isReady: boolean;
  setIsReady: React.Dispatch<React.SetStateAction<boolean>>;
  organizationId: string;
  accessToken: string;
  recommendationAccessToken: string;
  baseUrl: string;
  pipeline: string;
  searchHub: string;
  recommendationsPipeline: string;
  recommendationsHub: string;
  analyticsAccessToken?: string;
  analyticsEndpoint?: string;
  setEngine: React.Dispatch<React.SetStateAction<SearchEngine>>;
  engine: SearchEngine | undefined;
  recommendationEngine: ReturnType<typeof buildRecommendationEngine> | undefined;
  setRecommendationEngine: React.Dispatch<
    React.SetStateAction<ReturnType<typeof buildRecommendationEngine>>
  >;
}

const CoveoSearchInterfaceContext = createContext<ICoveoSearchInterfaceContext>({
  isReady: false,
  organizationId: '',
  accessToken: '',
  recommendationAccessToken: '',
  baseUrl: '',
  pipeline: '',
  searchHub: '',
  recommendationsPipeline: '',
  recommendationsHub: '',
  analyticsAccessToken: '',
  analyticsEndpoint: '',
  setIsReady: () => {},
  setEngine: () => {},
  engine: undefined,
  recommendationEngine: undefined,
  setRecommendationEngine: () => {},
});

export { CoveoSearchInterfaceContext };
